import constSubmittedStep from './submittedStep'
import constSubmittedType from './submittedType'

export const pleaseSelectApproveStatus = {
    //ถ้าเปลี่ยนตรงนี้จะต้องเปลี่ยนที่ Service ด้วยใช้ชื่อตัวแปลไปค้นหาที่ service ได้เลย
    th: '{{---กรุณาเลือกผลการพิจารณา---}}',
    en: '{{---Please select ethic review result---}}',
}

export const renderMode = {
    view: 'VIEW',
    edit: 'EDIT',
}

export const menuTab = {
    //stepID = lut_submitted_step
    tab1: {
        nameTH: 'ตรวจสอบเอกสาร',
        nameEN: 'Inspect documents',
        id: 0,
        stepID: constSubmittedStep.verifyDoc,
    },
    tab1Chairman: {
        nameTH: 'รายละเอียดโครงการ',
        nameEN: 'Project detail',
        id: 0,
        stepID: constSubmittedStep.verifyDoc,
    },
    tab1Committee: {
        nameTH: 'รายละเอียดโครงการ',
        nameEN: 'Project detail',
        id: 0,
        stepID: constSubmittedStep.verifyDoc,
    },
    tab2: {
        nameTH: 'กำหนดประเภทโครงการและกรรมการ',
        nameEN: 'Define project type and assign committee',
        id: 1,
        stepID: constSubmittedStep.specifyProjectType,
    },
    tab2Chairman: {
        nameTH: 'กำหนดประเภทโครงการและกรรมการ',
        nameEN: 'Define project type and assign committee',
        id: 1,
        stepID: constSubmittedStep.specifyProjectType,
    },
    tab2Commitee: {
        nameTH: 'ประเภทโครงการและรายชื่อกรรมการ',
        nameEN: 'Project type and list of committees',
        id: 1,
        stepID: constSubmittedStep.specifyProjectType,
    },
    tab3: {
        nameTH: 'กำหนดขอชุดโครงการที่ต้องส่ง',
        nameEN: 'Specify number of copies of project documents',
        id: 2,
        stepID: constSubmittedStep.specifyAdditionalDoc,
    },
    tab4: {
        nameTH: 'ชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก',
        nameEN: "Documents' project complete and Submit principal reviewer's comment",
        id: 3,
        stepID: constSubmittedStep.specifySchedule,
    },
    tab4Chairman: {
        nameTH: 'ชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก',
        nameEN: "Documents' project complete and Submit principal reviewer's comment",
        id: 3,
        stepID: constSubmittedStep.specifySchedule,
    },
    tab5: {
        nameTH: 'บันทึกข้อคิดเห็นของกรรมการ' /**PIN */,
        nameEN: "Compose committees' comment",
        id: 4,
        stepID: constSubmittedStep.commentary,
    },
    tab5Commitee: {
        nameTH: 'บันทึกข้อคิดเห็น',
        nameEN: 'Compose comment',
        id: 4,
        stepID: constSubmittedStep.commentary,
    },
    tab5Chairman: {
        nameTH: 'ข้อคิดเห็นของกรรมการ',
        nameEN: "Compose committees' comment",
        id: 4,
        stepID: constSubmittedStep.commentary,
    },
    tab6: {
        nameTH: 'สังเคราะห์/ลงความเห็น',
        nameEN: 'Synthesize comments',
        id: 5,
        stepID: constSubmittedStep.synthesis,
    },
    tab6Chairman: {
        nameTH: 'สังเคราะห์/ลงความเห็น',
        nameEN: 'Synthesize comments',
        id: 5,
        stepID: constSubmittedStep.synthesis,
    },
    tab7: {
        nameTH: 'ออกผลการพิจารณา',
        nameEN: 'Review result',
        id: 6,
        stepID: constSubmittedStep.synthesisReview,
    },
    tab8: {
        nameTH: 'ออกใบรับรอง',
        nameEN: 'Generate certificate',
        id: 7,
        stepID: constSubmittedStep.certification,
    },
    tab9: {
        nameTH: 'ลงนาม',
        nameEN: 'Sign',
        id: 8,
        stepID: constSubmittedStep.sign,
    },
    tab10: {
        nameTH: 'ลงนามแทน',
        nameEN: 'Sign on behalf of president and secretary',
        id: 9,
        stepID: constSubmittedStep.sign,
    },
    tab11: {
        nameTH: 'ออกใบบันทึกข้อความ',
        nameEN: 'Sign on behalf of president and secretary',
        id: 10,
        stepID: constSubmittedStep.memoMessage,
    },
    tabConfirmProjectWithdraw: {
        nameTH: 'รับทราบการถอน',
        nameEN: 'Confirm project withdraw',
        id: 11,
        stepID: constSubmittedStep.confirmProjectWithdraw,
    },

    //tab21 เป็นต้นไปจะเป็นของ researcher
    tab21: {
        nameTH: 'ยื่นเอกสารโครงการ',
        nameEN: `Submit project's document`,
        id: 21,
        stepID: constSubmittedStep.submit,
    },
    tab22: {
        nameTH: 'แจ้งขอชุดโครงการที่ต้องส่ง',
        nameEN: 'Inform number of copies of project documents',
        id: 22,
        stepID: 99,
    },
    tab23: {
        nameTH: 'ผลการพิจารณา',
        nameEN: 'Review result',
        id: 23,
        stepID: 99,
    },
    tab24: {
        nameTH: 'ใบรับรองและเอกสารประทับตรารับรอง',
        nameEN: 'Certificates and certified documents',
        id: 24,
        stepID: 99,
    },
    tab25: {
        nameTH: 'ยื่นเอกสารแก้ไข',
        nameEN: 'Submit revised document',
        id: 25,
        stepID: constSubmittedStep.submit,
    },
    tab26: {
        nameTH: 'ผลการพิจารณา (ครั้งก่อน)',
        nameEN: 'Previous review result',
        id: 26,
        stepID: 99,
    },
    tab12: {
        nameTH: 'สังเคราะห์/ลงความเห็น',
        nameEN: 'Post a comment',
        id: 5,
        stepID: constSubmittedStep.synthesis,
    },
}

export const menuFolder = {
    folder1: {
        nameTH: 'ส่งพิจารณาครั้งแรก',
        id: 0,
        isLastProcess: true,
    },
    folder2: {
        nameTH: 'แก้ไขหลังพิจารณา',
        id: 1,
        isLastProcess: false,
    },
    folder3: {
        nameTH: 'ปิด / ยุติโครงการ',
        id: 2,
        isLastProcess: false,
    },
}

export const submitTypeLut = [
    { id: '1', name: 'ปิด' },
    { id: '2', name: 'ยุติโครงการ' },
]

export const statusColorConstant = {
    status1: {
        //ร่าง
        textColor: '#000000',
        backgroundColor: '#e0e0e0',
        submittedStatusColor: '#BEBEBE',
        statusID: 1,
    },
    status2: {
        //ส่งเรื่องแล้ว
        textColor: '#FFFFFF',
        backgroundColor: '#F5E151',
        statusID: 2,
    },
    status3: {
        //รับเรื่องแล้ว
        textColor: '#FFFFFF',
        backgroundColor: '#ffd18f',
        statusID: 3,
    },
    status4: {
        //กำหนดกรรมการแล้ว
        textColor: '#FFFFFF',
        backgroundColor: '#EC8F14',
        statusID: 4,
    },
    status18: {
        //รอส่งผู้ทบทวน
        textColor: '#FFFFFF',
        backgroundColor: '#ff5000',
        statusID: 18,
    },
    status5: {
        //รอสังเคราะห์ความเห็น
        textColor: '#FFFFFF',
        backgroundColor: '#746CB0',
        statusID: 5,
    },
    status6: {
        //ดำเนินการทำใบรับรอง
        textColor: '#FFFFFF',
        backgroundColor: '#4ab4f6',
        statusID: 6,
    },
    status7: {
        //รอลงนาม
        textColor: '#FFFFFF',
        backgroundColor: '#5DABA7',
        statusID: 7,
    },
    status8: {
        //ดำเนินการเสร็จสมบูรณ์
        textColor: '#FFFFFF',
        backgroundColor: '#76E4B7',
        statusID: 8,
    },
    status9: {
        textColor: '#FFFFFF',
        backgroundColor: '#CB793A',
        statusID: 9,
    },
    status10: {
        textColor: '#FFFFFF',
        backgroundColor: '#CB793A',
        statusID: 10,
    },
    status11: {
        //เอกสารไม่ครบหรือไม่ถูกต้อง
        textColor: '#FFFFFF',
        backgroundColor: '#C1292E',
        statusID: 11,
    },
    status12: {
        textColor: '#FFFFFF',
        backgroundColor: '#FF0000',
        statusID: 12,
    },
    status14: {
        //กำลังพิจารณา
        textColor: '#FFFFFF',
        backgroundColor: '#9D7DB1',
        statusID: 14,
    },
    proceedingMemoMessage: {
        //ดำเนินการทำใบบันทึกข้อความ
        textColor: '#FFFFFF',
        backgroundColor: '#2c7dcb',
        statusID: 15,
    },
    waitingEditProject: {
        //รอแก้ไขโครงการ
        textColor: '#FFFFFF',
        backgroundColor: '#FFC300',
        statusID: 16,
        researcher: {
            textColor: '#FFFFFF',
            backgroundColor: '#FFAC07',
        },
    },
    statusReject: {
        textColor: '#FFFFFF',
        backgroundColor: '#ff0000',
        statusID: 4,
    },
    statusClose: {
        textColor: '#FFFFFF',
        backgroundColor: '#4f2828',
        statusID: 3,
    },
    status15: {
        // กำลังดำเนินการ
        textColor: '#FFFFFF',
        backgroundColor: '#FFAC07',
        statusID: 1,
        pendingBackgroundColor: '#8D8D8D',
    },
    resultOfConsideration: {
        //ดำเนินการออกผลพิจารณา
        textColor: '#FFFFFF',
        backgroundColor: '#2d5983',
        statusID: 13,
    },
    noScope: {
        //ไม่เข้าข้าย
        textColor: '#FFFFFF',
        backgroundColor: '#e57373',
        statusID: 5,
    },
    terminate: {
        //ยุติโครงการ
        textColor: '#FFFFFF',
        backgroundColor: '#a8865d',
        statusID: 6,
    },
    withdraw: {
        //ถอนโครงการ
        textColor: '#FFFFFF',
        backgroundColor: '#800000',
        statusID: 7,
    },
    status17: {
        //กำหนดกรรมการแล้ว
        textColor: '#FFFFFF',
        backgroundColor: '#ff9100',
        statusID: 17,
    },
}

export const configCertificate = {
    descriptionIRB1: {
        id: 1,
        nameTH: 'คณะกรรมการพิจารณาจริยธรรมการวิจัยในคน กลุ่มสหสถาบัน ชุดที่ 1 จุฬาลงกรณ์มหาวิทยาลัย ได้พิจารณาโดยใช้หลักของ Belmont Report 1979, Declaration of Helsinki 2013, Council for International Organizations of Medical Sciences (CIOM) 2016, มาตรฐานคณะกรรมการจริยธรรมการวิจัยในคน (มคจค.) 2560, นโยบายแห่งชาติและแนวทางปฏิบัติการวิจัยในมนุษย์ 2558 อนุมัติให้ดำเนินการศึกษาวิจัยเรื่องดังกล่าวได้',
        nameEN: 'The Research Ethics Review Committee for Research Involving Human Research Participants, Group I, Chulalongkorn University, Thailand, has approved constituted in accordance with Belmont Report 1979, Declaration of Helsinki 2013, Council for International Organizations of Medical Sciences (CIOM) 2016, Standards of Research Ethics Committee (SREC) 2017, and National Policy and guidelines for Human Research 2015.',
    },
    descriptionIRB1Exempt: {
        id: 2,
        nameTH: 'โครงการวิจัยนี้ได้รับการยกเว้นการทบทวนจริยธรรมการวิจัยโดยใช้หลักของ Office for Human Research Protections (OHRP Exempt Categories) 45 CFR part 46.101(b) โดยมีเงื่อนไขว่าผู้วิจัยดำเนินการวิจัยอย่างเคร่งครัดตามที่ปรากฏในโครงการวิจัยฉบับที่ส่งให้คณะกรรมการฯ พิจารณา หากมีการเปลี่ยนแปลงต้องแจ้งคณะกรรมการฯ ก่อนมีการดำเนินการวิจัยต่อไป',
        nameEN: 'This Research proposal is exempted for ethics review in compliance with the Office for Human Research Protections (OHRP Exempt Categories) 45 CFR part 46.101(b). Certified under condition: To conduct this research project, the researcher (s) must strictly adhere to research proposal approved by the committee. If there is any amendment, it must be sent to the committee for review before carrying on the project.',
    },
    descriptionIRB2: {
        id: 3,
        nameTH: 'คณะกรรมการพิจารณาจริยธรรมการวิจัยในคน กลุ่มสหสถาบัน ชุดที่ 2 สังคมศาสตร์ มนุษยศาสตร์ และศิลปกรรมศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย พิจารณาจริยธรรมการวิจัยโดยยึดหลัก ของ Declaration of Helsinki, the Belmont report, CIOMS guidelines และ The international conference on harmonization – Good clinical practice (ICH-GCP) อนุมัติให้ดำเนินการศึกษาวิจัยเรื่องดังกล่าวได้',
        nameEN: 'The Research Ethics Review Committee for Research Involving Human Subjects: The Second Allied Academic Group in Social Sciences, Humanities and Fine and Applied Arts at Chulalongkorn University, based on Declaration of Helsinki, the Belmont report, CIOMS guidelines and the Principle of the international conference on harmonization – Good clinical practice (ICH-GCP) has approved the execution of the aforementioned research project.',
    },
    conditionIRB1: {
        id: 4,
        nameTH: `1. ข้าพเจ้ารับทราบว่าเป็นการผิดจริยธรรม หากดำเนินการเก็บข้อมูลการวิจัยก่อนได้รับการอนุมัติจากคณะกรรมการพิจารณาจริยธรรมการวิจัยฯ
2. หากใบรับรองโครงการวิจัยหมดอายุ การดำเนินการวิจัยต้องยุติ เมื่อต้องการต่ออายุต้องขออนุมัติใหม่ล่วงหน้าไม่ต่ำกว่า 1 เดือน พร้อมส่งรายงานความก้าวหน้าการวิจัย
3. ต้องดำเนินการวิจัยตามที่ระบุไว้ในโครงการวิจัยอย่างเคร่งครัด
4. ใช้เอกสารข้อมูลสำหรับกลุ่มประชากรหรือผู้มีส่วนร่วมในการวิจัย ใบยินยอมของกลุ่มประชากรหรือผู้มีส่วนร่วมในการวิจัย และเอกสารเชิญเข้าร่วมวิจัย (ถ้ามี) เฉพาะที่ประทับตราคณะกรรมการเท่านั้น
5. หากเกิดเหตุการณ์ไม่พึงประสงค์ร้ายแรงในสถานที่เก็บข้อมูลที่ขออนุมัติจากคณะกรรมการ ต้องรายงานคณะกรรมการภายใน 5 วันทำการ
6. หากมีการเปลี่ยนแปลงการดำเนินการวิจัย ให้ส่งคณะกรรมการพิจารณารับรองก่อนดำเนินการ
7. หากยุติโครงการวิจัยก่อนกำหนดต้องแจ้งคณะกรรมการฯ ภายใน 2 สัปดาห์พร้อมคำชี้แจง
8. โครงการวิจัยไม่เกิน 1 ปี ส่งแบบรายงานสิ้นสุดโครงการวิจัย (AF 01-15) และบทคัดย่อผลการวิจัยภายใน 30 วัน เมื่อโครงการวิจัยเสร็จสิ้น สำหรับโครงการวิจัยที่เป็นวิทยานิพนธ์ให้ส่งบทคัดย่อผลการวิจัย ภายใน 30 วัน เมื่อโครงการวิจัยเสร็จสิ้น
9. โครงการวิจัยที่มีหลายระยะ จะรับรองโครงการเป็นระยะ เมื่อดำเนินการวิจัยในระยะแรกเสร็จสิ้นแล้ว ให้ดำเนินการส่งรายงานความก้าวหน้า พร้อมโครงการวิจัยและเอกสารที่เกี่ยวข้องในระยะถัดไป
10. คณะกรรมการฯ สงวนสิทธิ์ในการตรวจเยี่ยมเพื่อติดตามการดำเนินการวิจัย
11. สำหรับโครงการวิจัยจากภายนอก ผู้บริหารส่วนงาน กำกับการดำเนินการวิจัย`,
        nameEN: `The approved investigator must comply with the following conditions:
1. It’s unethical to collect data of research participants before the project has been approved by the committee.
2. The research/project activities must end on the approval expired date. To renew the approval, it can be applied one month prior to the expired date with submission of progress report.
3. Strictly conduct the research/project activities as written in the proposal.
4. Using only the documents that bearing the RECCU’s seal of approval: research tools, information sheet, consent form, invitation letter for research participation (if applicable).
5. Report to the RECCU for any serious adverse events within 5 working days. 
6. Report to the RECCU for any amendment of the research project prior to conduct the research activities.
7. Report to the RECCU for termination of the research project within 2 weeks with reasons.
8. Final report (AF 01-15) and abstract is required for a one year (or less) research/project and report within  30 days after the completion of the research/project. 
9. Research project with several phases; approval will be approved phase by phase, progress report and relevant documents for the next phase must be submitted for review.  
10. The committee reserves the right to site visit to follow up how the research project being conducted.
11. For external research proposal the dean or head of department oversees how the research being conducted.`,
    },
    conditionIRB1Exempt: {
        id: 5,
        nameTH: `โครงการวิจัยไม่เกิน 1 ปี ส่งแบบรายงานสิ้นสุดโครงการวิจัย (AF 01-15) และบทคัดย่อผลการวิจัยภายใน 30 วัน เมื่อโครงการวิจัยเสร็จสิ้น สำหรับโครงการวิจัยที่เป็นวิทยานิพนธ์ให้ส่งบทคัดย่อผลการวิจัย ภายใน 30 วัน เมื่อโครงการวิจัยเสร็จสิ้น`,
        nameEN: `Final report (AF 01-15) and abstract is required for a one year (or less) research/project and report within 30 days after the completion of the research/project.`,
    },
    conditionIRB2: {
        id: 6,
        nameTH: `1. ผู้วิจัยรับทราบว่าเป็นการผิดจริยธรรม หากดำเนินการเก็บข้อมูลการวิจัยก่อนได้รับการอนุมัติจากคณะกรรมการพิจารณาจริยธรรมการวิจัยฯ
2. หากใบรับรองโครงการวิจัยหมดอายุ การดำเนินการวิจัยต้องยุติ เมื่อต้องการต่ออายุต้องขออนุมัติใหม่ล่วงหน้าไม่ต่ำกว่า 1 เดือน พร้อมส่งรายงานความก้าวหน้าการวิจัย
3. ต้องดำเนินการวิจัยตามที่ระบุไว้ในโครงการวิจัยอย่างเคร่งครัด
4. ใช้เอกสารข้อมูลสำหรับกลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย ใบยินยอมของกลุ่มตัวอย่างหรือผู้มีส่วนร่วมในการวิจัย และเอกสารเชิญเข้าร่วมวิจัย (ถ้ามี) เฉพาะที่ประทับตราคณะกรรมการเท่านั้น 
5. หากเกิดเหตุการณ์ไม่พึงประสงค์ร้ายแรงในสถานที่เก็บข้อมูลที่ขออนุมัติจากคณะกรรมการ ต้องรายงานคณะกรรมการภายใน 5 วันทำการ
6. หากมีการเปลี่ยนแปลงการดำเนินการวิจัย ให้ส่งคณะกรรมการพิจารณารับรองก่อนดำเนินการ
7. โครงการวิจัยไม่เกิน 1 ปี ส่งแบบรายงานสิ้นสุดโครงการวิจัย (AF 03-13) และบทคัดย่อผลการวิจัยภายใน 30 วัน เมื่อโครงการวิจัยเสร็จสิ้น สำหรับโครงการวิจัยที่เป็นวิทยานิพนธ์ให้ส่งบทคัดย่อผลการวิจัย ภายใน 30 วัน เมื่อโครงการวิจัยเสร็จสิ้น ทั้งนี้เพื่อเป็นหลักฐานในการปิดโครงการ
8. โครงการวิจัยที่ได้รับการอนุมัติโครงการโดยการพิจารณาทบทวนแบบกรณียกเว้น (Exemption review) ปฏิบัติติตามเงื่อนไข ข้อ 1,6 และ 7 เท่านั้น`,
        nameEN: `1. The researcher has acknowledged that it is unethical if he/she collects information for the research before the application for an ethics review has been approved by the Research Ethics Review Committee.
2. If the certificate of the research project expires, the research execution must come to a halt. If the researcher wishes to reapply for approval, he/she has to submit an application for a new certificate at least one month in advance, together with a research progress report.
3. The researcher must conduct the research strictly in accordance with what is specified in the research project.
4. The researcher must only use documents that provide information for the research sampling population/participants, their letters of consent  and the letters inviting them to take part in the research (if any) that have been endorsed with the seal of the Committee.   
5. If any seriously untoward incident happens to the place where the research information, which has requested the approval of the Committee, is kept, the researcher must report this to the Committee within five working days.
6. If there is any change in the research procedure, the researcher must submit the change for review by the Committee before he/she can continue with his/her research.
7. For a research project of less than one year the researcher must submit a report of research termination (AF 03-13) and an abstract of the research outcome within thirty days of the research being completed.  For a research project which is a thesis, the researcher must submit an abstract of the research outcome within thirty days of the research being completed.  This is to be used as evidence of the termination of the project.
8. A research project which has passed the Exemption Review, must observe only the conditions in 1, 6 and 7.`,
    },
}

export const cerTopic = [
    {
        code: null,
        id: 0,
        name_en: 'Thai language',
        name_th: 'ภาษาไทย',
    },
    {
        code: null,
        id: 1,
        name_en: 'English language',
        name_th: 'ภาษาอังกฤษ',
    },
]

export const memorandumTopic = [
    {
        code: null,
        id: 0,
        name_en: 'Thai language',
        name_th: 'ภาษาไทย',
    },
    {
        code: null,
        id: 1,
        name_en: 'English language',
        name_th: 'ภาษาอังกฤษ',
    },
]

type CutomFolderType = {
    folderName_en: string
    folderName_th: string
    submittedID: number
    submittedStatusID: number
    id: number
    isLastProcess: boolean
}

export const customFolder = {
    createProject: {
        nameTH: 'ส่งพิจารณาครั้งแรก',
        id: 0,
        isLastProcess: true,
        folderName_en: 'Submit for first consideration',
        folderName_th: 'ส่งพิจารณาครั้งแรก',
        submittedID: 0,
        submittedStatusID: 0,
        submittedTypeID: constSubmittedType.firstSubmitConsideration,
    },
    docAdditional: {
        folderName_en: 'Sent other types of documents',
        folderName_th: 'ยื่นเอกสารเพื่อพิจารณา',
        submittedID: -999,
        submittedStatusID: -999,
        id: -999,
        isLastProcess: false,
        submittedTypeID: -999,
    } as CutomFolderType,
    closeProject: <CutomFolderType>{
        folderName_en: 'Close project',
        folderName_th: 'ปิดโครงการ',
        submittedID: -998,
        submittedStatusID: -998,
        id: -998,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.closeProject,
    },
    projectPhase: <CutomFolderType>{
        folderName_en: 'Project phase',
        folderName_th: 'โครงการระยะถัดไป',
        submittedID: -997,
        submittedStatusID: -997,
        id: -997,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.nextPhaseProject,
    },
    projectAmendment: <CutomFolderType>{
        folderName_en: 'Project amendment after approval',
        folderName_th: 'แก้ไขโครงการหลังได้รับอนุมัติ',
        submittedID: -996,
        submittedStatusID: -996,
        id: -996,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.amendmentProject,
    },
    projectRenewal: <CutomFolderType>{
        folderName_en: 'Project Renewal',
        folderName_th: 'ขอต่ออายุโครงการ',
        submittedID: -995,
        submittedStatusID: -995,
        id: -995,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.renewalProject,
    },
    raeProject: {
        folderName_en: 'Reported a nonconformance',
        folderName_th: 'รายงานไม่เป็นไปตามข้อกำหนด',
        submittedID: -994,
        submittedStatusID: -994,
        id: -994,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.nonconformance,
    } as CutomFolderType,
    terminateProject: <CutomFolderType>{
        folderName_en: 'Terminate Project',
        folderName_th: 'ยุติโครงการ',
        submittedID: -993,
        submittedStatusID: -993,
        id: -993,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.terminateProject,
    },
    adverseEvents: <CutomFolderType>{
        folderName_en: 'Adverse events',
        folderName_th: 'รายงานเหตุการณ์ที่ไม่พึงประสงค์',
        submittedID: -992,
        submittedStatusID: -992,
        id: -992,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.adverseEvent,
    },
    closeProjectByAdmin: <CutomFolderType>{
        folderName_en: 'Request for close project (admin)',
        folderName_th: 'ขอปิดโครงการ (โดยเจ้าหน้าที่)',
        submittedID: -991,
        submittedStatusID: -991,
        id: -991,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.closeProjectByAdmin,
    },
    terminateProjectByAdmin: <CutomFolderType>{
        folderName_en: 'Request for terminate project (admin)',
        folderName_th: 'ขอยุติโครงการ (โดยเจ้าหน้าที่)',
        submittedID: -990,
        submittedStatusID: -990,
        id: -990,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.terminateProjectByAdmin,
    },
    withdrawProject: <CutomFolderType>{
        folderName_en: 'Project withdrawal (all projects)',
        folderName_th: 'ถอนโครงการ (การถอนทั้งโครงการ)',
        submittedID: -989,
        submittedStatusID: -989,
        id: -989,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.withdrawalProject,
    },
    withdrawSubmitted: <CutomFolderType>{
        folderName_en: 'Project withdrawal (Submitted)',
        folderName_th: 'ถอนโครงการ (การถอนเฉพาะครั้งนั้น)',
        submittedID: -988,
        submittedStatusID: -988,
        id: -988,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.withdrawalSubmitted,
    },
    projectFilesUpload: <CutomFolderType>{
        folderName_en: 'Upload Files',
        folderName_th: 'อัปโหลดเอกสาร',
        submittedID: -987,
        submittedStatusID: -987,
        id: -987,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.projectFilesUpload,
    },
    renewalAndAmendmentProject: <CutomFolderType>{
        folderName_en: 'Request for amendment and extension of the project.',
        folderName_th: 'ขอแก้ไขพร้อมต่ออายุโครงการ',
        submittedID: -986,
        submittedStatusID: -986,
        id: -986,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.renewalAndAmendmentProject,
    },

    highRiskProjectProgressReport: <CutomFolderType>{
        folderName_en: 'High Risk Project Progress Report',
        folderName_th: 'รายงานความก้าวหน้าโครงการที่มีความเสี่ยงสูง',
        submittedID: -985,
        submittedStatusID: -985,
        id: -985,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.highRiskProjectProgressReport,
    },

    projectSiteVisit: <CutomFolderType>{
        folderName_en: 'Inspection Documents',
        folderName_th: 'เอกสารสำหรับตรวจเยี่ยม',
        submittedID: -984,
        submittedStatusID: -984,
        id: -984,
        isLastProcess: false,
        submittedTypeID: constSubmittedType.projectSiteVisit,
    },
}

export const educationLevel = [
    {
        id: 1,
        name_th: 'ปริญญาตรี',
        name_en: 'Bachelor Degree',
    },
    {
        id: 2,
        name_th: 'ปริญญาโท',
        name_en: 'Masters Degree',
    },
    {
        id: 3,
        name_th: 'ปริญญาเอก',
        name_en: 'Doctoral Degree',
    },
]

export const fileExt = {
    pdf: '.pdf',
    doc: '.doc',
    docx: '.docx',
    tiff: '.tiff',
    png: '.png',
    jpg: '.jpg',
    xlsx: '.xlsx',
    xls: '.xls',
}

export const fileExtUploadFilelist = ['.pdf', '.doc', '.docx', '.tiff', '.png', '.jpg']

export const isTitleName = {
    dr: {
        nameTH: 'ดร.',
        nameEN: 'Dr.',
        value: 1,
    },
}

export const topicForStudent = [
    {
        id: 7,
        name_th: 'เอกสารอนุมัติหัวข้อวิทยานิพนธ์ (สำหรับนิสิตระดับบัณฑิตศึกษา)',
        name_en: 'Thesis Title Approval Document',
    },
    {
        id: 10,
        name_th: 'บันทึกข้อความสำหรับโครงร่างวิทยานิพนธ์ (สำหรับนิสิตระดับบัณฑิตศึกษา)',
        name_en: 'A Cover Letter for Thesis Proposals',
    },
    {
        id: 16,
        name_th: 'เอกสารอนุมัติหัวข้อวิทยานิพนธ์ (สำหรับนิสิตระดับบัณฑิตศึกษา)',
        name_en: 'Thesis Title Approval Document',
    },
    {
        id: 23,
        name_th: 'สำเนาบทคัดย่อ (Abstract) (ที่มีการลงนามครบถ้วนสำหรับนิสิตระดับบัณฑิตศึกษา)',
        name_en: 'Abstract (Prepared by researcher)',
    },
]

export const topicForLecturer = [
    {
        id: 29,
        name_th: 'บันทึกข้อความสำหรับข้อเสนอโครงการวิจัย (สำหรับอาจารย์/นักวิจัย)',
        name_en: 'A Cover Letter for Non-Thesis Research Projects',
    },
]
export const topicIsExempt = [
    {
        id: 1,
        name_en: 'Suggestion / Notice',
        name_th: 'ข้อคิดเห็น / ข้อสังเกต',
        no: null,
        irb: null,
    },
]

export const topicIsUploadComment = [
    {
        id: 1,
        no: null,
        name_en: 'Record the opinions of the main reviewer.',
        name_th: 'บันทึกความคิดเห็นของผู้ทบทวนหลัก',
    },
]

export const fixPosition = [
    { id: '1', name: 'อาจารย์', shortName: 'อ.' },
    { id: '2', name: 'ผู้ช่วยศาสตราจารย์', shortName: 'ผศ.' },
    { id: '3', name: 'รองศาสตราจารย์', shortName: 'รศ.' },
    { id: '4', name: 'ศาสตราจารย์', shortName: 'ศ.' },
    { id: '5', name: 'ศาสตราจารย์กิตติคุณ', shortName: 'ศ.กิตติคุณ' },
    { id: '6', name: 'อื่นๆ', shortName: 'etc.' },
    { id: '7', name: 'ไม่ระบุ', shortName: '' },
]
